export default function customTicketButton() {
  const widgetName = 'customTicketButton';
  const widgetOpts = customTicketButtonOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    imageIsBackground: false,
    showDescription: false,
    lazyLoadImages: false,
    buyNowButton: false,
    moreButton: false,
    hasImages: false,
    link: ['all'],
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    textOverImage: true,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData && data.items[0].URL) {
        createCustomTicketButton(widgetName);
      } else {
        $widgetHTML.remove();
      }
    },
  });

  function createCustomTicketButton(widgetName) {
    const card = $(`#${widgetName} .card-widget-item`);
    card.prepend('<div id="gloss"><div>');
    card.find('.buttonwrap').remove();
  }
}
